module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d3cdd105293785bafc302d53039d5001.gif";